module.exports = __webpack_public_path__ + "static/img/des2.be7e9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/buycardgetcoupon/des2.png
// module id = JbZh
// module chunks = 0